module.exports = __webpack_public_path__ + "img/album17_08.81baf22e.jpg";